import { createRequest } from "urql";

import { graphqlClient } from "src/api";
import { PRODUCT_IMPORT_FILE_UPLOAD } from "src/api/graphql-api/product/product.gql";
import { Params, RequestParams, RequestParamsKeys } from "./finish-import-modal.types";

export const getRequestParams = (params: Params): RequestParams => {
  return Object.entries(params).reduce((acc, [_, value]) => {
    const key = _ as RequestParamsKeys;

    if (value) acc[key] = true;
    else acc[key] = undefined;

    return acc;
  }, {} as RequestParams);
};

/**
 * Archive the original uploaded import files (excel/csv) on the backend.
 * Fire-and-forget: failures must not block the product import flow and are only logged.
 */
export const uploadImportSourceFiles = (files: File[]): void => {
  files.forEach((file) => {
    graphqlClient
      .executeMutation(createRequest(PRODUCT_IMPORT_FILE_UPLOAD, { file }))
      .toPromise()
      .then((result) => {
        if (result.error) {
          console.error("Failed to archive product import file: ", result.error);
        }
      })
      .catch((error) => {
        console.error("Failed to archive product import file: ", error);
      });
  });
};
